import React from "react";
import "./Container.css"; // Ensure this CSS file exists and is in the correct location

const Smallercont = ({ children }) => {
  return <div className="smallercont">{children}</div>;
};

export default Smallercont;
